import React from 'react'
import { graphql } from 'gatsby'
import { faqDataFormatter } from '../libs/helpers'
import Layout from '../libs/Layout'
import AccordionGroup from '../components/AccordionGroup'
import Hero from '../components/Hero'
import HomeDoctor from '../components/HomeDoctor'
import LinkList from '../components/LinkList'
import LinkListTitle from '../components/LinkListTitle'
import LinkListTeaser from '../components/LinkListTeaser'
import Recruiter from '../components/Recruiter'
import Seo from '../components/Seo'
import Teaser from '../components/Teaser'
import Tabs from '../components/Tabs'
import Video from '../components/Video'
import VideoCarousel from '../components/VideoCarousel'
import VideoGroup from '../components/VideoGroup'
import Wayfinding from '../components/Wayfinding'
import Specialties from '../components/Specialties'
import ComparisonChart from '../components/ComparisonChart'

export const Head = ({ data, location }) => <Seo {...data.strapiPage.seo} location={location} />

const PageTemplate = ({ data }) => {
  let page = data.strapiPage
  if (page.title === 'FAQ') page = faqDataFormatter(page)

  return (
    <Layout>
      <Hero title={page.title} heroData={page.hero} />
      {page?.main
        ?.filter((c) => Object.keys(c).length)
        .map((component, i) => {
          const type = component?.strapi_component?.split('.')[1]
          let module = undefined
          // console.log(component)
          switch (type) {
            case 'accordion-group':
              module = <AccordionGroup key={i} {...component} />
              break
            case 'home-doctor':
              module = <HomeDoctor key={i} {...component} doctors={data.allStrapiDoctor.nodes} />
              break
            case 'link-list':
              module = <LinkList key={i} {...component} />
              break
            case 'link-list-title':
              module = <LinkListTitle key={i} {...component} />
              break
            case 'link-list-teaser':
              module = <LinkListTeaser key={i} {...component} />
              break
            case 'recruiter':
              module = <Recruiter key={i} {...component} />
              break
            case 'teaser':
              module = <Teaser key={i} {...component} />
              break
            case 'tabs':
              module = <Tabs key={i} {...component} />
              break
            case 'specialties-list':
              module = <Specialties key={i} {...component} />
              break
            case 'comparison-chart':
              module = <ComparisonChart key={i} {...component} />
              break
            case 'video':
              // GOTCHA: make sure video is published
              module = component[type] ? <Video key={i} {...component} /> : undefined
              break
            case 'video-carousel':
              module = <VideoCarousel key={i} {...component} />
              break
            case 'video-group':
              module = <VideoGroup key={i} {...component} />
              break
            case 'wayfinding':
              module = <Wayfinding key={i} {...component} />
              break
            default:
              module = (
                <section key={i}>
                  undefined module: <strong>{type}</strong>
                </section>
              )
          }
          return module
        })}
    </Layout>
  )
}

export default PageTemplate

export const query = graphql`
  query ($id: String!) {
    strapiPage(id: { eq: $id }) {
      title
      seo {
        ...SeoData
      }
      hero {
        ...HeroData
      }
      main {
        ... on STRAPI__COMPONENT_COMPONENT_ACCORDION {
          strapi_component
          ...AccordionGroup
        }
        ... on STRAPI__COMPONENT_COMPONENT_LINK_LIST {
          strapi_component
          ...LinkListData
        }
        ... on STRAPI__COMPONENT_COMPONENT_TEASER {
          strapi_component
          ...TeaserData
        }
        ... on STRAPI__COMPONENT_COMPONENT_TABS {
          strapi_component
          ...TabsData
        }
        ... on STRAPI__COMPONENT_COMPONENT_VIDEO {
          strapi_component
          ...VideoData
        }
        ... on STRAPI__COMPONENT_COMPONENT_WAYFINDING {
          strapi_component
          ...WayfindingData
        }
        ... on STRAPI__COMPONENT_SUPERCUSTOM_HOME_DOCTOR {
          strapi_component
          ...HomeDoctorData
        }
        ... on STRAPI__COMPONENT_SUPERCUSTOM_LINK_LIST_TITLE {
          strapi_component
          ...LinkListTitleData
        }
        ... on STRAPI__COMPONENT_SUPERCUSTOM_LINK_LIST_TEASER {
          strapi_component
          ...LinkListTeaserData
        }
        ... on STRAPI__COMPONENT_SUPERCUSTOM_RECRUITER {
          strapi_component
          ...RecruiterData
        }
        ... on STRAPI__COMPONENT_SUPERCUSTOM_VIDEO_CAROUSEL {
          strapi_component
          ...VidCarouselData
        }
        ... on STRAPI__COMPONENT_SUPERCUSTOM_VIDEO_GROUP {
          strapi_component
          ...VideoGroupData
        }
        ... on STRAPI__COMPONENT_SUPERCUSTOM_SPECIALTIES_LIST {
          strapi_component
          ...SpecialtiesListData
        }
        ... on STRAPI__COMPONENT_SUPERCUSTOM_COMPARISON_CHART {
          strapi_component
          ...comparisonChartData
        }
      }
    }
    allStrapiDoctor {
      nodes {
        branch
        id
        image {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 150)
            }
          }
        }
        job
        name
        slug
      }
    }
  }
`
